"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "Section", {
  enumerable: true,
  get: function get() {
    return _Section.default;
  }
});
var _Section = _interopRequireDefault(require("./Section"));
function cov_l6aaz006z() {
  var path = "/codebuild/output/src589783736/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Section/lib/index.js";
  var hash = "ed937bc94bffd10f22a13d97eb9bdf8d15d5e613";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src589783736/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Section/lib/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ed937bc94bffd10f22a13d97eb9bdf8d15d5e613"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_l6aaz006z = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_l6aaz006z();